"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var lineChart = exports.lineChart = { "viewBox": "0 0 2048 1792", "children": [{ "name": "path", "attribs": { "d": "M2048 1536v128h-2048v-1536h128v1408h1920zM1920 288v435q0 21-19.5 29.5t-35.5-7.5l-121-121-633 633q-10 10-23 10t-23-10l-233-233-416 416-192-192 585-585q10-10 23-10t23 10l233 233 464-464-121-121q-16-16-7.5-35.5t29.5-19.5h435q14 0 23 9t9 23z" } }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/fa/lineChart.js
// module id = 1238
// module chunks = 0